


























































































































































































































































































import { Vue, Prop, Component, Watch } from "vue-property-decorator";
import {
  LearningRequest as ILearningRequest,
  LearningRequestStatusEnum
} from "@/api/models/learning-request";
import { learningType } from "@/plugins/learning-type";
import { availableStatuses, learningStatus } from "@/plugins/learning-status";
import api, { courseApi, settingStorageApi } from "@/getinfo-api";
import CustomTableItem from "@/components/form/CustomTableItem.vue";
import CustomTableCol from "@/components/form/CustomTableCol.vue";
import { LearningRequestChangeStatus as ILearningRequestChangeStatus } from "@/api/models/learning-request-change-status";
import { EnrollmentOrder as IEnrollmentOrder } from "@/api/models/enrollment-order";
import { ExpulsionOrder as IExpulsionOrder } from "@/api/models/expulsion-order";
import { EducationProtocol as IEducationProtocol } from "@/api/models/education-protocol";
import { AxiosError } from "axios";
import {
  ErrorResponse as IErrorResponse,
  ValidationErrorResponse as IValidationErrorResponse
} from "@/api/models";
import CustomButton from "@/components/form/CustomButton.vue";
import Modal from "@/components/form/Modal.vue";
import ListenerInRequestList from "@/components/orders/ListenerInRequestList.vue";
import CourseRegistrationsTable from "@/components/courses/CourseRegistrationsTable.vue";
import { isAllowEditDates, studentLimitModule } from "@/plugins/modules-detect";
import CustomDatepicker from "@/components/form/CustomDatepicker.vue";
import EnrollmentOrderForm from "@/components/enrollment/EnrollmentOrderForm.vue";
import EducationProtocolForm from "@/components/education/EducationProtocolForm.vue";
import ExpulsionOrderForm from "@/components/expulsion/ExpulsionOrderForm.vue";
import { getCurrentCompanyId } from "@/plugins/roles";

@Component({
  components: {
    ExpulsionOrderForm,
    EducationProtocolForm,
    EnrollmentOrderForm,
    CustomDatepicker,
    CourseRegistrationsTable,
    ListenerInRequestList,
    Modal,
    CustomButton,
    CustomTableCol,
    CustomTableItem
  },
  computed: {
    isAllowToEditDates: isAllowEditDates
  }
})
export default class ImportedLearningRequestItem extends Vue {
  @Prop() propRequest!: ILearningRequest;
  @Prop() index!: number;
  isShowFormedAt: boolean = false;
  enrollements: IEnrollmentOrder[] = [];
  expulsions: IExpulsionOrder[] = [];
  protocols: IEducationProtocol[] = [];
  isDisable: boolean = false;
  isOpenEnrollmentOrder: boolean = false;
  isOpenEducationProtocol: boolean = false;
  isOpenExpullOrder: boolean = false;
  status!: string;
  finishedAt: Date = new Date();
  course!: any;
  isShowStartedAt: boolean = false;
  isShowFinishedAt: boolean = false;

  startedAt!: Date | undefined;
  formedAt!: Date | undefined;
  request!: ILearningRequest;
  data() {
    return {
      course: undefined,
      request: undefined,
      status: undefined,
      startedAt: undefined
    };
  }

  get checkCourse() {
    return this.request.resourceType === "course"
      ? this.request.resourceId
      : undefined;
  }

  saveEnrollment(item: IEnrollmentOrder) {
    this.enrollements = [...this.enrollements, item];
    this.isOpenEnrollmentOrder = false;
  }
  saveProtocol(item: IEducationProtocol) {
    this.protocols = [...this.protocols, item];
    this.isOpenEducationProtocol = false;
  }
  saveExpulsion(item: IExpulsionOrder) {
    this.expulsions = [...this.expulsions, item];
    this.isOpenExpullOrder = false;
  }

  generate(): string {
    return Math.random()
      .toString(36)
      .substring(7);
  }

  @Watch("propRequest")
  checkPropRequest() {
    this.request = this.propRequest;

    this.status = this.request.status;
  }

  created() {
    this.request = this.propRequest;
    this.startedAt = this.request.startedAt;
    if (this.request.resourceType === "course") {
      api.CourseApi.get(this.request.resourceId).then(res => {
        this.course = res.data;
      });
    }
    if (this.request.resourceType === "course2") {
      courseApi.CourseInfo.getCourseInfo(this.request.resourceId).then(res => {
        this.course = {};
        this.course.hours = res.data.hours;
      });
    }

    this.status = this.request.status;
  }

  countStartFromFinished() {
    this.startedAt = this.$store.getters["companyUtils/GET_START_FROM_FINISH"](
      this.finishedAt,
      this.course.hours
    );
  }

  countFinishFromStart() {
    this.finishedAt = this.$store.getters["companyUtils/GET_FINISH_FROM_START"](
      this.startedAt,
      this.course.hours
    );
  }

  openExpullsion() {
    this.isOpenExpullOrder = true;
  }

  openProtocol() {
    this.isOpenEducationProtocol = true;
  }

  getMaterialType(type: string) {
    return learningType(type);
  }

  getFormattedStatus(item: string) {
    return learningStatus(item);
  }

  get allStatuses() {
    return availableStatuses();
  }

  saveStartedAt() {
    if (this.startedAt) {
      api.LearningRequestApi.changeStartedAt(this.request.id, {
        startedAt: this.startedAt
      })
        .then(() => {
          this.request.startedAt = this.startedAt;
          this.isShowStartedAt = false;
          this.$emit("clearChecked");
        })
        .catch((err: AxiosError<IValidationErrorResponse | IErrorResponse>) => {
          this.$store.dispatch("errorException", {
            vm: this,
            error: err.response
          });
        });
    }
  }

  saveFormedAt() {
    api.LearningRequestApi.changeFormedAt(this.request.id, {
      formedAt: this.formedAt ? this.formedAt : this.request.formedAt
    })
      .then(res => {
        this.isShowFormedAt = false;
        //@ts-ignore
        this.request.formedAt = res.data?.formedAt;
        this.$emit("clearChecked");
      })
      .catch((err: AxiosError<IValidationErrorResponse | IErrorResponse>) => {
        this.$store.dispatch("errorException", {
          vm: this,
          error: err.response
        });
      });
  }

  get companyId(): string {
    return getCurrentCompanyId();
  }

  async getStudentLimit() {
    settingStorageApi.Company.getCompanySettings(this.companyId, [
      "studentLimit"
    ]).then(res => {
      //@ts-ignore
      this.$store.state.studentLimit = +res.data[0].value.amount;
    });
  }
  async getStudentActive() {
    api.CourseApi.listenersCountGlobal(this.companyId).then(res => {
      this.$store.state.studentAmount = +res.data;
    });
  }

  get isStudentLimitModule() {
    return studentLimitModule() && this.$store.state.studentLimit !== 0;
  }

  get isBlockAddStudent() {
    return (
      this.isStudentLimitModule &&
      this.$store.state.studentLimit - this.$store.state.studentAmount <
        this.request.users.length &&
      (this.request.status === LearningRequestStatusEnum.NotProcessed ||
        this.request.status === LearningRequestStatusEnum.WaitingPayment) &&
      this.request.resourceType !== "course2"
    );
  }

  changeStatus() {
    this.isDisable = true;
    let params: ILearningRequestChangeStatus = {
      //@ts-ignore
      status: this.status,
      handle: true
    };
    api.LearningRequestApi.changeStatus(this.request.id, params)
      .then((res: { data: ILearningRequest }) => {
        this.status = res.data.status;
        this.request = res.data;
        this.getStudentActive();
        this.getStudentLimit();
        if (
          params.status === "learning_finished" &&
          this.$store.getters["companyUtils/getIsFinishLearningWithEndLr"]
        ) {
          api.CourseApi.pass(
            res.data.resourceId,
            //@ts-ignore
            (res.data.payload.course_listeners as string[]).map(el => {
              return { listenerId: el, success: true };
            })
          );
        }
        this.$emit("clearChecked");
        this.$bvToast.toast(
          this.$tc(this.$translate.ChangesHaveBeenSuccessfullySaved),
          {
            variant: "success",
            title: this.$tc(this.$translate.Successful)
          }
        );
      })
      .catch((err: AxiosError<IValidationErrorResponse | IErrorResponse>) => {
        this.status = this.request.status;
        this.$store.dispatch("errorException", {
          vm: this,
          error: err.response
        });
      })
      .finally(() => {
        this.isDisable = false;
      });
  }
}
